import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';

export const ProjectsApp: ComponentType<unknown> & LoadableExport.LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "projects-app-entry" */ '@townsquare/projects/app'),
	loading: () => null,
});
